module.exports = __webpack_public_path__ + "img/25.cd5ac932.png";